export default {
      id: "Icon--badgeRecordedAudio-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--badgeRecordedAudio",
      toString: function () {
        return this.url;
      }
    }